import { useState } from "react";
import { entryLinks } from "@/mocks/home";
import SectionHeading from "@/components/feature/SectionHeading";

const filters = ["全部", "正常", "维护中"] as const;

export default function EntryBoard() {
  const [active, setActive] = useState<(typeof filters)[number]>("全部");
  const [copied, setCopied] = useState("");

  const list =
    active === "全部"
      ? entryLinks
      : entryLinks.filter((item) => item.status === active);

  const copyDomain = async (domain: string) => {
    try {
      await navigator.clipboard.writeText(domain);
    } catch {
      const el = document.createElement("textarea");
      el.value = domain;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
    }
    setCopied(domain);
    window.setTimeout(() => setCopied(""), 1800);
  };

  return (
    <section id="entry" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-content px-4">
        <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="最新可用入口"
            title="当前可用地址一览"
            desc="以下入口均经过线路巡检整理，状态会随官方维护情况变化。建议同时收藏 2–3 条线路，遇到主入口拥堵或被屏蔽时可随时切换。"
          />
          <div className="mb-8 flex shrink-0 items-center gap-1 rounded-full bg-background-100 p-1 md:mb-10">
            {filters.map((f) => (
              <button
                key={f}
                type="button"
                onClick={() => setActive(f)}
                className={
                  active === f
                    ? "cursor-pointer rounded-full bg-primary-500 px-4 py-1.5 text-sm font-medium text-background-50"
                    : "cursor-pointer rounded-full px-4 py-1.5 text-sm font-medium text-foreground-600 transition-colors hover:text-foreground-900"
                }
              >
                {f}
              </button>
            ))}
          </div>
        </div>

        <div className="flex flex-col gap-4">
          {list.map((item) => (
            <article
              key={item.id}
              className="flex flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 md:flex-row md:items-center md:justify-between md:p-5"
            >
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                    {item.name}
                  </span>
                  <span className="inline-flex items-center gap-1 rounded-full bg-primary-100 px-2.5 py-0.5 text-xs font-medium text-primary-800">
                    {item.tag}
                  </span>
                  <span
                    className={
                      item.status === "正常"
                        ? "inline-flex items-center gap-1 rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs font-medium text-secondary-900"
                        : "inline-flex items-center gap-1 rounded-full bg-accent-100 px-2.5 py-0.5 text-xs font-medium text-accent-800"
                    }
                  >
                    <span
                      className={
                        item.status === "正常"
                          ? "h-1.5 w-1.5 rounded-full bg-primary-500"
                          : "h-1.5 w-1.5 rounded-full bg-accent-500"
                      }
                    ></span>
                    {item.status}
                  </span>
                </div>

                <div className="mt-2 flex items-center gap-2">
                  <i className="ri-global-line text-foreground-400"></i>
                  <span className="break-all font-mono text-sm text-foreground-800">
                    {item.domain}
                  </span>
                </div>

                <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                  {item.note}
                </p>

                <div className="mt-3 flex flex-wrap items-center gap-x-5 gap-y-1 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1.5">
                    <i className="ri-speed-up-line"></i>
                    速度：{item.speed}
                  </span>
                  <span className="inline-flex items-center gap-1.5">
                    <i className="ri-route-line"></i>
                    适用线路：{item.region}
                  </span>
                </div>
              </div>

              <div className="flex shrink-0 items-center gap-2">
                <button
                  type="button"
                  onClick={() => copyDomain(item.domain)}
                  className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700"
                >
                  <i
                    className={
                      copied === item.domain ? "ri-check-line" : "ri-file-copy-line"
                    }
                  ></i>
                  {copied === item.domain ? "已复制" : "复制地址"}
                </button>
              </div>
            </article>
          ))}
        </div>

        <p className="mt-6 flex items-start gap-2 rounded-lg bg-background-100 p-4 text-xs leading-relaxed text-foreground-600">
          <i className="ri-information-line mt-0.5 text-primary-600"></i>
          温馨提示：入口状态以官方公告为准，本页仅作导航整理。如果某条线路暂时打不开，请先切换到其他线路，而不是反复刷新同一个地址。
        </p>
      </div>
    </section>
  );
}